export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40731e24438d81ef5c4c3acc4441a5d3abbf0a8124&name=revalidateCommunity!'